require('./dist/vue-plain-slider.css') // component style
module.exports = require('./dist/vue-plain-slider.umd.min.js') // component
